<template>
  <div class="raffle-result-card-wrapper">
    <v-card
      class="card pa-4"
      color="neutral1"
      :class="{ 'border-golden': raffle.winner?._id === _user?._id }"
      outlined
    >
      <div class="d-flex flex-column">
        <template v-if="raffle.winner">
          <div class="d-flex align-center mb-2">
            <v-icon color="amber" left> fas fa-trophy </v-icon>

            <div class="text-h6">
              {{
                raffle.winner?._id === _user?._id ? "Você" : raffle.winner?.name
              }}
              foi
              <span class="amber--text font-weight-bold"> PREMIADO(A)! </span>
            </div>
          </div>

          <div class="text-body-1 mb-3">
            {{ raffle.winner?._id === _user?._id ? "Seu" : "O" }}
            número

            <span class="font-weight-bold neutral4 px-1">{{
              formatResult(raffle.result)
            }}</span>

            foi o sorteado da vez.
          </div>

          <div class="text-body-1 neutral8--text">
            O valor de
            <span class="font-weight-bold text1--text">
              R${{ currencyMask(raffle.awards?.cash) }}
            </span>
            foi creditado e já está disponível

            <span v-if="raffle.winner?._id === _user?._id">
              em
              <router-link
                class="text1--text font-weight-bold"
                :to="{ name: 'Wallet' }"
              >
                sua carteria
              </router-link>
            </span>
          </div>

          <div v-if="raffle.externalLink" class="mt-1">
            <a
              class="text-body-1 accent--text font-weight-bold"
              :href="raffle.externalLink"
              target="_blank"
            >
              Ver vídeo do ganhador
            </a>
          </div>
        </template>

        <template v-else>
          <div class="text-h6 result-text mb-1">
            O número sorteado foi
            <span class="accent--text font-weight-bold">
              {{ formatResult(raffle.result) }}
            </span>
          </div>

          <div class="text-body-1 neutral8--text">
            Nenhum participante foi premiado. Acompanhe os próximos concursos,
            continue tentando!
          </div>
        </template>
      </div>
    </v-card>

    <template v-if="detailed">
      <!-- Cotas premiadas -->
      <div
        v-if="raffle?.luckyTokens?.filter((el) => el.winner).length"
        class="d-flex flex-column mt-4"
      >
        <div class="text-h6 mb-1 pl-2">Cotas Premiadas</div>

        <v-card
          v-for="(item, i) in raffle?.luckyTokens?.filter((el) => el.winner)"
          :key="i"
          class="card py-2 px-3 mb-1 rounded-lg"
          color="neutral1"
          outlined
        >
          <div class="d-flex align-center">
            <div>
              <div class="d-flex align-center">
                <v-icon left small> mdi-ticket-outline </v-icon>

                <div class="text-body-2 font-weight-bold">{{ item.token }}</div>
              </div>

              <div class="text-caption neutral8--text">
                Adquirido por
                {{ item.winner ? item.winner?.name : "--" }}
              </div>
            </div>

            <v-spacer />

            <div class="text-body-2 font-weight-bold accent--text">
              R$ {{ currencyMask(item.awards?.cash) }}
            </div>
          </div>
        </v-card>
      </div>

      <loader v-if="loadingRanking" />

      <div v-else-if="ranking && ranking?.winners?.length" class="mt-4">
        <div class="text-h6 mb-1 pl-2">
          Ganhador(es) do ranking de apoiadores
        </div>

        <v-card
          v-for="(item, i) in ranking.winners"
          :key="i"
          class="card pa-3 mb-1 rounded-lg"
          color="neutral1"
          outlined
        >
          <div class="d-flex align-center">
            <v-icon color="amber" left small> mdi-crown </v-icon>

            <div class="text-body-2 font-weight-bold">
              {{ item.person.name }}
            </div>

            <v-spacer />

            <div class="text-body-2 font-weight-bold accent--text">
              R$ {{ currencyMask(item.rewards?.money) }}
            </div>
          </div>
        </v-card>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatResult, currencyMask } from "@/helpers";

export default {
  name: "ResultRaffleCard",

  props: {
    raffle: {
      type: Object,
      required: true,
    },

    ranking: {
      type: Object,
      default: () => {},
    },

    detailed: {
      type: Boolean,
      default: false,
    },

    loadingRanking: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({ _user: "user" }),
  },

  methods: {
    formatResult,

    currencyMask,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
